module.exports = __webpack_public_path__ + "6c0a5c48ca0abab155ca0845b9e29e47.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-karate.png
// module id = 1346
// module chunks = 0